import { render, staticRenderFns } from "./addressDialog.vue?vue&type=template&id=80a1ab60&scoped=true&"
import script from "./addressDialog.vue?vue&type=script&lang=js&"
export * from "./addressDialog.vue?vue&type=script&lang=js&"
import style0 from "./addressDialog.vue?vue&type=style&index=0&id=80a1ab60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80a1ab60",
  null
  
)

export default component.exports